module.exports = __webpack_public_path__ + "static/media/dajianshan_package.12ec0b87.webp";